import {ChangeDetectorRef, Component} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../_services/auth.service";
import {User} from '../_types/user';
import {CommunitiesService} from "../_services/communities.service";
import {environment} from "../../environments/environment";
import {ThemeService} from "../_services/theme.service";
import {Community} from "../_types/communities";
import {LocalStorageService} from "../_services/local-storage.service";
import {ContentService} from "../_services/content.service";
import {NavigationEnd, Router} from "@angular/router";
import {animate, group, query, style, transition, trigger} from "@angular/animations";

@Component({
    selector: 'app-unauthview',
    templateUrl: './unauthview.component.html',
    styleUrl: './unauthview.component.scss',
    animations: [
        trigger('openClose', [
            transition('closed => open', group([
                query('rect:nth-child(1)', [
                    animate('300ms ease-out', style({
                        transform: 'translateY(32.5px) translateX(-25px) rotate(45deg)',
                        transformOrigin: '50% 50%'
                    }))
                ]),
                query('rect:nth-child(2)', [
                    animate('150ms ease-out', style({
                        opacity: 0
                    }))
                ]),
                query('rect:nth-child(3)', [
                    animate('300ms ease-out', style({
                        transform: 'translateY(-12.5px) translateX(-22.5px) rotate(-45deg)',
                        transformOrigin: '50% 50%'
                    }))
                ])
            ])),

            transition('open => closed', group([
                query('rect:nth-child(1)', [
                    animate('300ms ease-out', style({
                        transform: 'translateY(0) translateX(0) rotate(0)',
                        transformOrigin: '50% 50%'
                    }))
                ]),
                query('rect:nth-child(2)', [
                    animate('150ms ease-out', style({
                        opacity: 1
                    }))
                ]),
                query('rect:nth-child(3)', [
                    animate('300ms ease-out', style({
                        transform: 'translateY(0) translateX(0) rotate(0)',
                        transformOrigin: '50% 50%'
                    }))
                ])
            ])),
        ]),
    ],

})
export class UnauthviewComponent {
    companyImg: string = localStorage.getItem('communityLogo') || 'assets/explainLogoPlaceholder.png';
    backgroundImage: string = localStorage.getItem('communityLoginBG') || '';
    loggedIn: boolean = false;
    menuOpen: boolean = false;
    primaryColor: string = environment.primaryColor || '#1B9AAA';
    accentColor: string = environment.accentColor || '#c93457';
    backgroundColour: null | string = null;
    loginNavColour: null | string = null;
    listItems: any[] = [];
    isLogin: boolean = location.pathname.includes('login');

    constructor(protected themeService: ThemeService,
                private authService: AuthService,
                private contentService: ContentService,
                public dialog: MatDialog,
                private cdr: ChangeDetectorRef,
                private readonly localStorageService: LocalStorageService,
                private readonly communitiesService: CommunitiesService,
                private router: Router
    ) {
        this.loggedIn = this.authService.isLoggedIn();
        this.backgroundColour = null;
        this.backgroundImage = '';
        this.loginNavColour = null;

        if (!this.loggedIn || !this.selectedCommunity || this.isLogin) {
            this.communitiesService.getCommunityByUrl().then((r): void => {
                this.setCommunity(r)
                this.themeService.savePrimaryColor(this.primaryColor)
                this.themeService.saveAccentColor(this.accentColor)
            }).catch(e => {
                this.themeService.savePrimaryColor(this.primaryColor)
                this.themeService.saveAccentColor(this.accentColor)
            });
        } else if (this.selectedCommunity) {
            this.setCommunity(this.selectedCommunity)
        }

        this.router.events.forEach((event: any): void => {
            if (event instanceof NavigationEnd) {
                this.isLogin = location.pathname.includes('login');
                if (this.selectedCommunity) {
                    this.setCommunity(this.selectedCommunity)
                }
            }
        });
    }

    get selectedCommunity(): Community | null {
        return this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null);
    }

    get currentUser(): User {
        return this.authService.getUser();
    }

    get isWebView(): boolean {
        return navigator.userAgent.includes("Android") && (navigator.userAgent.includes("wv") || navigator.userAgent.includes("WebView"))
    }

    setCommunity(community: Community): void {
        this.backgroundImage = '';
        if (community?.dashboard_navbar_logo) {
            this.companyImg = community?.dashboard_navbar_logo;
        } else if (community?.logo) {
            this.companyImg = community?.logo;
        }
        this.loginNavColour = null;
        if (this.isLogin) {
            this.backgroundImage = community.background_image;
            this.loginNavColour = community.login_header_color_hex || null;
            this.cdr.detectChanges();
        } else if (location.pathname.includes('privacy-policy') && community.privacy_policy_background_image) {
            this.backgroundImage = community.privacy_policy_background_image
        } else if (location.pathname.includes('terms-and-conditions') && community.terms_and_conditions_background_image) {
            this.backgroundImage = community.terms_and_conditions_background_image
        } else if (location.pathname.includes('communicationPreferences') && community.communication_preferences_background_image) {
            this.backgroundImage = community.communication_preferences_background_image
        } else if (community.main_background_image) {
            this.backgroundImage = community.main_background_image
        }
        if (community.main_color_hex) {
            this.primaryColor = community.main_color_hex;
        }
        this.themeService.savePrimaryColor(this.primaryColor)

        if (community.accent_color_hex) {
            this.accentColor = community.accent_color_hex;
        }
        if (community?.logo_background_color_hex) {
            document.documentElement.style.setProperty(
                `--logo-background`, community?.logo_background_color_hex
            );
        }
        this.themeService.saveAccentColor(this.accentColor)
        this.listItems = [];
        this.contentService.getCommunityPages(community?.id).subscribe(resp => {
            const id: RegExpMatchArray | null = location.pathname.match(/[^/]+$/);
            for (let result of resp.results) {
                if (result.id == id && location.pathname.includes('info')) {
                    if (result.background_color_hex) {
                        this.backgroundImage = '';
                        this.backgroundColour = result.background_color_hex;
                    }
                    if (result.background_image) {
                        this.backgroundImage = result.background_image;
                    }
                }
                if (result.show_on_login_page) {
                    this.listItems.push(result)
                }
            }
        })
    }

    onAnimationDone(menuOpen: boolean): void {
        this.menuOpen = menuOpen;
    }

}
